import { qualityMessage } from "../../utils/directorFormat";

const contentFor = (state, reasonCode) => {
  if (reasonCode === "sales_contracts_restricted_or_rule_missing") return {
    title: "Chaves indisponíveis",
    explanation: qualityMessage("key_handover_unavailable"),
    action: "Liberar Sales Contracts ou aprovar uma regra de domínio.",
  };
  if (reasonCode === "received_not_normalized_to_corrected_basis") return {
    title: "Base corrigida indisponível",
    explanation: "Recebido e previsto ainda não estão normalizados na mesma base corrigida.",
    action: "Concluir a normalização do indexador antes de comparar valores corrigidos.",
  };
  const states = {
    loading: {
      title: "Carregando clientes e recebimentos…",
      explanation: "Consultando a última revisão autorizada.",
    },
    empty: {
      title: "Nenhum recebimento no recorte",
      explanation: "Altere empresa, empreendimento, cliente ou período para ampliar a busca.",
    },
    restricted: {
      title: "Fonte de recebimentos restrita",
      explanation: qualityMessage("source_restricted"),
      action: "Liberar a leitura de Parcelas a Receber no usuário de API do Sienge.",
    },
    unavailable: {
      title: "Informação indisponível",
      explanation: "A fonte necessária ainda não publicou um valor confiável.",
    },
    stale: {
      title: "Dados desatualizados",
      explanation: qualityMessage(reasonCode || "stale"),
      action: "Confira a data da última atualização antes de decidir.",
    },
    partial: {
      title: "Cobertura parcial",
      explanation: "A leitura permanece disponível, mas há limitações de classificação ou cobertura.",
    },
    error: {
      title: "Não foi possível atualizar os recebimentos",
      explanation: "A última tentativa falhou sem publicar valores novos.",
    },
  };
  return states[state] || null;
};

const AvailabilityPanel = ({
  state,
  reasonCode = null,
  message = null,
  onRetry,
}) => {
  const content = contentFor(state, reasonCode);
  if (!content || state === "normal") return null;
  const role = state === "error" ? "alert" : "status";
  return <section
    className={`director-state director-state--${state}`}
    data-state={state}
    role={role}
  >
    <strong>{content.title}</strong>
    <p>{message || content.explanation}</p>
    {content.action && <small>{content.action}</small>}
    {state === "error" && onRetry && <button
      className="director-button"
      onClick={onRetry}
      type="button"
    >
      Tentar novamente
    </button>}
  </section>;
};

export default AvailabilityPanel;
